import { InputNumber, InputNumberProps } from "antd";
import type { ValueType } from "rc-input-number";
import LargeArrowRight from "../icons/LargeArrowRight";
import Skeleton from "../Skeleton/Skeleton";
import StatusTag from "../StatusTag/StatusTag";
import styles from "./InputUnitConversion.module.scss";

export interface InputUnitConversionProps<T extends ValueType> extends InputNumberProps<T> {
  sourceUnit: string;
  targetUnit: string;
  rootStatus: "validating" | "complete" | "incomplete";
}

export default function InputUnitConversion<T extends ValueType = ValueType>({
  sourceUnit,
  targetUnit,
  rootStatus,
  ...inputProps
}: InputUnitConversionProps<T>) {
  return (
    <div className={styles.InputUnitConversion}>
      <div className={styles["start-unit"]}>1 {sourceUnit}</div>
      <div className={styles.arrow}>
        <LargeArrowRight />
      </div>
      <div className={styles["target-unit"]}>
        <InputNumber<T>
          {...inputProps}
          addonAfter={targetUnit}
          required={true}
          controls={false}
        />
      </div>
      <div className={styles.status}>
        {rootStatus === "validating" ? (
          <Skeleton style={{ width: "90px", height: "24px" }} />
        ) : (
          <StatusTag
            status={rootStatus}
            showIcon={false}
          />
        )}
      </div>
    </div>
  );
}
